import { Component } from 'react';
import ReactDOM from 'react-dom'

class Modal extends Component {
  constructor(props) {
    super(props);
    this.modalDiv = document.createElement('div');
    this.modalRoot = document.querySelector('body');
  }

  componentDidMount() {
    this.modalRoot.appendChild(this.modalDiv);
    document.body.classList.add('stop-scroll');
  }

  componentWillUnmount() {
    this.modalRoot.removeChild(this.modalDiv);
    document.body.classList.remove('stop-scroll');
  }

  render() {
    return ReactDOM.createPortal(
      this.props.children,
      this.modalDiv
    );
  }
}

export default Modal;
